import { render, staticRenderFns } from "./BoardSidebar.vue?vue&type=template&id=907710dc&"
import script from "./BoardSidebar.vue?vue&type=script&lang=js&"
export * from "./BoardSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports